<template>
  <div class="home-page">
    <Header></Header>
    <Menulist></Menulist>
    <!-- ===== 轮播图（数据来源 banner/active_list） ===== -->
    <!--    <div class="banner-row" v-if="bannerList.length > 0">-->
    <!--      <el-carousel height="500px" :interval="4000" arrow="hover">-->
    <!--        <el-carousel-item v-for="item in bannerList" :key="item.id">-->
    <!--          <img-->
    <!--              class="banner-row__img"-->
    <!--              :src="item.image"-->
    <!--              :alt="item.title"-->
    <!--              @click="openBanner(item)"-->
    <!--          >-->
    <!--        </el-carousel-item>-->
    <!--      </el-carousel>-->
    <!--    </div>-->
    <div class="page-main">
      <!-- ===== 运营商卡片（数量自适应：1 项占整行 / 2 项各半 / 3 项各 1/3） ===== -->
      <div class="stat-row" :class="'stat-row--' + (carriers.length > 3 ? 3 : carriers.length)">
        <div
            class="stat-card"
            v-for="c in carriers"
            :key="c.key"
            :style="{ borderLeftColor: c.color }"
        >
          <div class="stat-card__head">
            <img class="stat-card__logo" :src="c.logo" alt="">
            <span class="stat-card__name" :style="{ color: c.color }">{{ c.name }}</span>
          </div>

          <div class="stat-card__total">
<!--            <span class="stat-card__total-label">网卡总数</span>-->
            <span class="stat-card__total-value"><b :style="{ color: c.color }">{{ c.info.total }}</b> 张</span>
          </div>

          <div class="stat-card__list">
            <div class="stat-item"><i style="background:#6dd400"></i>正常<b>{{ c.info.zcsl || 0 }}</b></div>
            <div class="stat-item"><i style="background:#e02020"></i>测试<b>0</b></div>
            <div class="stat-item"><i style="background:#0091ff"></i>停机<b>{{ c.info.gqsl || 0 }}</b></div>
            <div class="stat-item"><i style="background:#6d7278"></i>其他<b>0</b></div>
          </div>
        </div>

        <div class="stat-empty" v-if="carriers.length == 0">暂无可统计的网卡数据</div>
      </div>



      <!-- ===== 图表 ===== -->
      <div class="chart-row">
        <el-row :gutter="20">
          <el-col :xs="24" :md="12">
            <el-card class="data-card">
              <div slot="header" class="card-head"><span>终端统计</span></div>
              <Echarts :option="option" style="height: 260px;" />
            </el-card>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-card class="data-card">
              <div slot="header" class="card-head"><span>流量监控 Top5</span></div>
              <Echarts :option="options" style="height: 260px;" />
            </el-card>
          </el-col>
        </el-row>
      </div>

      <!-- ===== 通知公告 / 常见问题 ===== -->
      <div class="news-row">
        <!-- type="flex" 让两列自动等高 -->
        <el-row :gutter="20" type="flex">
          <el-col :xs="24" :md="12">
            <el-card class="data-card">
              <div slot="header" class="card-head">
                <span>通知公告</span>
                <el-button class="card-head__more" type="text" @click="noticelist">更多</el-button>
              </div>
              <div class="news-list">
                <div
                    class="news-item"
                    v-for="o in notice"
                    :key="o.id || o.title"
                    @click="clicknotice(o)"
                >
                  <span class="news-item__title">{{ o.title }}</span>
                  <span class="news-item__time">{{ o.addtime }}</span>
                </div>
                <div class="news-empty" v-if="notice.length == 0">暂无信息</div>
              </div>
            </el-card>
          </el-col>

          <el-col :xs="24" :md="12">
            <el-card class="data-card">
              <div slot="header" class="card-head">
                <span>常见问题</span>
                <el-button class="card-head__more" type="text" @click="knowledgelist">更多</el-button>
              </div>
              <div class="news-list">
                <div
                    class="news-item"
                    v-for="o in problem"
                    :key="o.id || o.answer"
                    @click="clickknowledge(o)"
                >
                  <span class="news-item__title">{{ o.answer }}</span>
                  <span class="news-item__time">{{ o.addtime }}</span>
                </div>
                <div class="news-empty" v-if="problem.length == 0">暂无信息</div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>

    <Footer></Footer>

    <!-- 通知公告详情 -->
    <el-dialog title="通知公告" :visible.sync="noticestatus" width="60%">
      <div class="dialog-row"><b>标题：</b><span>{{ noticecontent.title }}</span></div>
      <div class="dialog-row"><b>时间：</b><span>{{ noticecontent.addtime }}</span></div>
      <div class="dialog-block">
        <b>内容</b>
        <div class="dialog-content" v-html="noticecontent.content"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="noticestatus = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 问题解答详情 -->
    <el-dialog title="问题解答" :visible.sync="knowledgestatus" width="60%">
      <div class="dialog-row"><b>标题：</b><span>{{ knowledgecontent.answer }}</span></div>
      <div class="dialog-row"><b>时间：</b><span>{{ knowledgecontent.addtime }}</span></div>
      <div class="dialog-block">
        <b>内容</b>
        <div class="dialog-content" v-html="knowledgecontent.question"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="knowledgestatus = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 完善开票信息提示 -->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="420px" :before-close="handleClose">
      <div class="dialog-tip">请完善开票信息，补全再进行下一步！</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="NetUserinfo()">去完善</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Footer from "@/components/footer/index.vue";
import Menulist from "@/components/menulist/index.vue"
import Header from "@/components/heard/index.vue";
import yidong from "@/assets/home/yidong.png";
import dianxin from "@/assets/home/dianxin.png";
import lianton from "@/assets/home/lianton.png";
import Echarts from "@/components/charts/Echarts.vue";
import {
  card_getCardCountByYys,
  card_getTopCards, conf_list,
  content_contentlist, getInfo,
  knowledge_queryknowledgelist,
  terminal_getCardCountByStatus,
  banner_active_list,
} from '@/api/manage' // 接口

export default {
  components: {Header, Menulist, Footer, Echarts},
  data() {
    return {
      dialogVisible: false,
      yidonglogo: yidong,
      dianxinlogo: dianxin,
      liantonlogo: lianton,
      noticestatus: false,
      noticecontent: '',
      knowledgestatus: false,
      knowledgecontent: '',
      notice: [],
      problem: [],
      bannerList: [],   // 轮播图（banner/active_list）
      option: {},
      options: {},
      dianxininfo: {},
      liantoninfo: {},
      yidonginfo: {},
    }
  },
  computed: {
    // 三家运营商统一成一份配置，模板里 v-for 渲染（只展示有数据的）
    carriers() {
      return [
        {key: 'yidong', name: '中国移动', color: '#0081CC', logo: this.yidonglogo, info: this.yidonginfo},
        {key: 'lianton', name: '中国联通', color: '#E34238', logo: this.liantonlogo, info: this.liantoninfo},
        {key: 'dianxin', name: '中国电信', color: '#175BBE', logo: this.dianxinlogo, info: this.dianxininfo},
      ].filter(c => Number(c.info.total) > 0)
    }
  },
  created() {
    this.getinfo()
    this.getBannerList()
    getInfo({}).then(response => {
      localStorage.setItem('yscode', response.user.userName);
      // 邮箱或姓名缺失时提示去完善
      if ((response.user.email == '' || response.user.email == null) || (response.user.nickName == null || response.user.nickName == "")) {
        this.dialogVisible = true
      } else {
        this.dialogVisible = false
      }
    })
    conf_list({appid: "card_shengtang"}).then((response) => {
      localStorage.setItem('configdata', JSON.stringify(response.data))
      this.configdata = response.data
    });
  },
  methods: {
    // 轮播图：banner/active_list（appid 固定 card_shengtang）
    getBannerList() {
      banner_active_list({appid: 'card_shengtang'}).then(response => {
        const res = response && response.data
        // 兼容两种返回结构：data 直接是数组，或 data.data 才是数组
        const list = Array.isArray(res) ? res : (res && Array.isArray(res.data) ? res.data : [])
        // 后端字段命名可能是 image / img / imageUrl 等，这里统一映射一次
        this.bannerList = list.map((item, index) => ({
          id: item.id || index,
          image: item.image || item.img || item.imageUrl || item.picUrl || item.picture || item.bannerimg || '',
          link: item.url || item.link || item.jumpUrl || '',
          title: item.title || item.name || ''
        })).filter(item => !!item.image)
      }).catch(() => {
        this.bannerList = []
      })
    },

    // 有跳转地址时，点击轮播图在新窗口打开
    openBanner(item) {
      if (item.link) {
        window.open(item.link, '_blank')
      }
    },

    handleClose() {
      this.dialogVisible = true
    },
    NetUserinfo() {
      this.$router.push('/userinfo');
    },
    // 运营商网卡数量 + 终端统计饼图 + 流量 Top5 柱状图 + 公告 / 常见问题
    getinfo() {
      card_getCardCountByYys({}).then(response => {
        if (response.code == 0) {
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].yys == '电信') {
              this.dianxininfo = response.data[i];
            } else if (response.data[i].yys == '联通') {
              this.liantoninfo = response.data[i];
            } else if (response.data[i].yys == '移动') {
              this.yidonginfo = response.data[i];
            }
          }

          terminal_getCardCountByStatus({}).then(response => {
            const total = response.data.total;
            this.option = {
              tooltip: {
                trigger: 'item'
              },
              legend: {
                orient: 'vertical',
                left: 'left'
              },
              series: [
                {
                  name: '终端设备统计',
                  type: 'pie',
                  radius: ['40%', '70%'],
                  data: [
                    {value: response.data.zcsl, name: '正常'},
                    {value: response.data.gqsl, name: '停机'},
                  ],
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  }
                }
              ],
              // 圆心显示总数
              graphic: {
                elements: [
                  {
                    type: 'text',
                    left: 'center',
                    top: 'center',
                    style: {
                      text: `${total}台`,
                      x: 0,
                      y: 0,
                      textAlign: 'center',
                      textVerticalAlign: 'middle',
                      fontSize: 24,
                      fontWeight: 'bold',
                      fill: '#333'
                    }
                  }
                ]
              }
            }
          })

          card_getTopCards().then(res => {
            const data = res.data
            var iccidlist = []
            var icciddata = []
            for (let i = 0; i < data.length; i++) {
              if (i < 4) {
                iccidlist.push(data[i].iccid)
                icciddata.push(data[i].trafficOfMonth)
              }
            }

            this.options = {
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                }
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              xAxis: [
                {
                  type: 'category',
                  data: iccidlist,
                  axisTick: {
                    alignWithLabel: true
                  }
                }
              ],
              yAxis: [
                {
                  type: 'value'
                }
              ],
              series: [
                {
                  name: '本月使用流量',
                  type: 'bar',
                  barWidth: '60%',
                  data: icciddata
                }
              ]
            }
          })

          // 公告ID：688513922941061
          content_contentlist({page: 1, pagesize: 5, catid: 688513922941061}).then(response => {
            this.notice = response.data.data
          })

          // 知识库ID：688508956799109
          knowledge_queryknowledgelist({page: 1, pagesize: 5, catid: 696334410236037}).then(response => {
            this.problem = response.data.data
          })
        }
      })
    },
    clicknotice(row) {
      this.noticestatus = true
      this.noticecontent = row
    },
    noticelist() {
      this.$router.push('/noticelist');
    },
    clickknowledge(row) {
      this.knowledgestatus = true
      this.knowledgecontent = row
    },
    knowledgelist() {
      this.$router.push('/knowledgelist');
    }
  }
}
</script>

<style lang="scss" scoped>
.home-page {
  min-height: 100vh;
  background-color: #f5f6f8;
  background-image: url('../../assets/bg1.png');
  background-size: 100% 100%;
  background-position: center;
  background-attachment: fixed;
}

.page-main {
  width: 100%;
  padding: 18px 30px 24px;
  box-sizing: border-box;
  background: #fff;
  //margin: -200px 30px 24px;
  //position: relative;
  //z-index: 9999999;
}

/* ===== 运营商卡片 =====
   一行内的卡片等分：1 项占满整行、2 项各 1/2、3 项各 1/3（由 flex:1 自动均分） */
.stat-row {
  display: flex;
  gap: 18px;
  margin-bottom: 18px;
}

.stat-card {
  flex: 1 1 0;
  min-width: 0;
  padding: 16px 18px;
  border: 1px solid #ebeef5;
  border-left: 3px solid #ebeef5;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}

.stat-card__head {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px dashed #f0f2f5;
}

.stat-card__logo {
  width: 28px;
  height: 26px;
  margin-right: 10px;
  object-fit: contain;
}

.stat-card__name {
  font-size: 15px;
  font-weight: 600;
}

.stat-card__total {
  font-size: 13px;
  color: #86909c;

  b {
    margin-right: 4px;
    font-size: 26px;
    font-weight: 700;
  }
}

/* 总数小标题：卡片式布局下不显示，仅单项横排时出现 */
.stat-card__total-label {
  display: none;
}

.stat-card__list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 14px;
  margin-top: 10px;
}

.stat-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #4e5969;

  i {
    flex: none;
    width: 6px;
    height: 6px;
    margin-right: 8px;
    border-radius: 50%;
  }

  b {
    margin-left: auto;
    font-weight: 600;
    color: #1d2129;
  }
}

.stat-empty {
  flex: 1 1 100%;
  padding: 34px 0;
  border: 1px dashed #e5e6eb;
  border-radius: 12px;
  background: #fff;
  text-align: center;
  font-size: 13px;
  color: #86909c;
}

/* 只有一项时：改成横排——图标区 + 总数区合占 40%，四项状态平分剩下 60% */
.stat-row--1 .stat-card {
  display: flex;
  align-items: center;
  padding: 18px 26px;
}

.stat-row--1 .stat-card__head {
  flex: 0 0 20%;
  box-sizing: border-box;
  padding-bottom: 0;
  padding-right: 24px;
  margin-bottom: 0;
  border-bottom: none;
  border-right: none;
}

.stat-row--1 .stat-card__logo {
  width: 40px;
  height: 36px;
  margin-right: 12px;
}

.stat-row--1 .stat-card__name {
  font-size: 16px;
}

.stat-row--1 .stat-card__total {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 20%;
  box-sizing: border-box;
  padding: 0 24px;
  border-right: 1px solid #dcdfe6;

  b {
    font-size: 32px;
    margin-right: 6px;
  }
}

/* 单项横排：总数带小标题，四项状态放到浅底面板里，两组明显区分 */
.stat-row--1 .stat-card__total-label {
  display: block;
  margin-bottom: 2px;
  font-size: 12px;
  line-height: 18px;
  color: #86909c;
}

.stat-row--1 .stat-card__total-value {
  display: block;
  line-height: 40px;
  white-space: nowrap;
}

.stat-row--1 .stat-card__list {
  flex: 0 0 calc(60% - 16px);
  box-sizing: border-box;
  grid-template-columns: repeat(4, 1fr);
  gap: 0 16px;
  margin-top: 0;
  margin-left: 16px;
  padding: 12px 18px;
  border-radius: 10px;
  background: #fafbfc;
}

/* ===== 轮播图 ===== */
.banner-row {
  margin-bottom: 20px;
  //border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.banner-row ::v-deep .el-carousel__item {
  border-radius: 12px;
  overflow: hidden;
}

.banner-row__img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

/* ===== 区块间距 ===== */
.chart-row {
  margin-bottom: 20px;
}

.news-row {
  margin-bottom: 4px;
}

/* 两栏各占一半且高度一致：列变成 flex 容器，卡片撑满列高 */
.news-row ::v-deep .el-col {
  display: flex;
}

.news-row ::v-deep .data-card {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.news-row ::v-deep .data-card > .el-card__body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* 卡片标题：红色竖条，与个人中心一致 */
.card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    position: relative;
    padding-left: 12px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 16px;
      border-radius: 2px;
      background: linear-gradient(180deg, #f56c6c 0%, #e53935 100%);
    }
  }
}

.card-head__more {
  padding: 0 !important;
  font-size: 13px !important;
}

/* ===== 公告 / 常见问题列表 ===== */
.news-list {
  flex: 1;
  min-height: 0;
  max-height: 320px;
  margin: -6px 0;
  overflow-y: auto;
}

.news-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;

  & + .news-item {
    border-top: 1px solid #f5f6f8;
  }

  &:hover {
    background: #fafbfc;

    .news-item__title {
      color: #e53935;
    }
  }
}

.news-item__title {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #1d2129;
  transition: color 0.2s;
}

.news-item__time {
  flex: none;
  margin-left: 16px;
  font-size: 12px;
  color: #86909c;
}

.news-empty {
  padding: 30px 0;
  text-align: center;
  font-size: 13px;
  color: #86909c;
}

/* ===== 弹窗内容 ===== */
.dialog-row {
  display: flex;
  padding: 8px 0;
  font-size: 14px;
  color: #4e5969;

  b {
    flex: none;
    margin-right: 6px;
    color: #1d2129;
  }
}

.dialog-block {
  margin-top: 10px;
  padding-top: 12px;
  border-top: 1px solid #f0f2f5;
  font-size: 14px;
  color: #1d2129;
}

.dialog-content {
  margin-top: 8px;
  font-size: 14px;
  line-height: 28px;
  color: #4e5969;
}

.dialog-tip {
  padding: 10px 14px;
  border-radius: 8px;
  background: #fef0f0;
  color: #e53935;
  font-size: 13px;
}

/* 中等屏：允许换行，横向单项布局收紧 */
@media screen and (max-width: 1100px) {
  .stat-row {
    flex-wrap: wrap;
  }

  .stat-card {
    flex: 1 1 260px;
  }

  .stat-row--1 .stat-card {
    padding: 16px 20px;
  }

  .stat-row--1 .stat-card__head {
    padding-right: 16px;
  }

  .stat-row--1 .stat-card__total {
    padding: 0 16px;
  }

  .stat-row--1 .stat-card__list {
    padding: 10px 14px;
    gap: 0 10px;
  }
}

/* 窄屏：统一切回纵向卡片 */
@media screen and (max-width: 768px) {
  .page-main {
    padding: 16px 16px 24px;
  }

  .stat-card {
    flex: 1 1 100%;
  }

  .stat-row--1 .stat-card {
    display: block;
    padding: 16px 18px;
  }

  .stat-row--1 .stat-card__head {
    width: auto;
    padding-right: 0;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-right: none;
    border-bottom: 1px dashed #f0f2f5;
  }

  .stat-row--1 .stat-card__total {
    flex-direction: row;
    align-items: baseline;
    padding: 0;
    border-right: none;

    b {
      font-size: 26px;
      margin-right: 4px;
    }
  }

  .stat-row--1 .stat-card__total-label {
    display: none;
  }

  .stat-row--1 .stat-card__total-value {
    line-height: 1.3;
  }

  .stat-row--1 .stat-card__list {
    width: auto;
    grid-template-columns: 1fr 1fr;
    gap: 6px 14px;
    margin-top: 10px;
    margin-left: 0;
    padding: 0;
    border-radius: 0;
    background: transparent;
  }
}
</style>
